import { useEffect } from "react";
import PageWrapper from "../components/shared/PageWrapper";
import { useSocket } from "../contexts/SocketContext";
import { useNavigate, useParams } from "react-router-dom";
import { usePreventIndex } from "../hooks/usePreventIndex";

const JoinRoomPage = () => {

  usePreventIndex();

  const navigate = useNavigate();
  const {setJoinIntention, user, rejoinRoom, leaveRoom} = useSocket();

  const {roomCode} = useParams();
  
  useEffect(() => {
    if (!roomCode) return;
    if (!user?.joinedRoom) joinNewRoom(roomCode);
  }, []);

  const joinNewRoom = (code: string) => {
    setJoinIntention(code);
    if (user?.joinedRoom && user.joinedRoom !== code) leaveRoom(); //leaveRoom navigates home for us
    else navigate('/');
  }

  const roomExists = !!user?.joinedRoom;

  return (
    <PageWrapper>
      <div className="item-list large-gap center-vertical center-horizontal">
        <p className="body">
          {!roomExists ? 'Joining Room' : "You are already in a room: " + user.joinedRoom}
        </p>
        {roomExists && 
          <div className="item-row">
            <button className="subtle" onClick={() => rejoinRoom()}>
              Go to Room
            </button>
            {roomCode && 
              <button className="subtle" onClick={() => joinNewRoom(roomCode)}>
                Join New Room
              </button>
            }
          </div>
        }
      </div>
    </PageWrapper>
  )
}
export default JoinRoomPage;